module.exports = __webpack_public_path__ + "static/media/main_cap_ic.04adc92c.png";